import React, { Component } from 'react'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import Config from '../../commons/config/Config.js'
import Dialog from '../../commons/dialog/Dialog.js'
import DropzoneComponent from 'react-dropzone-component/dist/react-dropzone'
import Select from 'react-select'
import {FormattedMessage, injectIntl} from 'react-intl';

class OTAdjuntos extends Component {
    constructor(props) {
        super(props);
        this.props = props;

        if (props.ticket) {
            this.ticket = props.ticket;
        }

        this.state = {
            adjuntos: [{
                id: -1,
                nombre: 'Sin categoría',
                adjuntos: []
            }
            ],
            categoria: null,
            categorias: [],
            tabSelected: -1
        };

        this.initFileUpload();

        this.selectTab = this.selectTab.bind(this);
        this.handleCategoriaChange = this.handleCategoriaChange.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleViewAdjunto = this.handleViewAdjunto.bind(this);
        this.handleRemoveAdjunto = this.handleRemoveAdjunto.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    componentDidMount() {
        this.initForm();
        if (this.props.onRef)
            this.props.onRef(this);
    }

    componentWillUnmount() {
        this.ajaxHandler.unsubscribe();
        if (this.props.onRef)
            this.props.onRef(undefined);
    }

    initForm() {
        this.ajaxHandler = new AjaxHandler();
        this.ajaxHandler.subscribe(this);

        let component = this;
        Promise.all([
            this.ajaxHandler.getJson('/categorias/select'),
            this.ajaxHandler.getJson('/tickets/' + this.props.ticket.id),
        ]).then((data) => {
            let categorias = data[0] ? data[0] : [];
            component.ticket = data[1];
            categorias.unshift({ value: -1, label: component.props.intl.formatMessage({ id: 'oTAdjuntos.category.select_sin_categoria', defaultMessage: 'Sin categoría' }) });

            let adjuntosCategorias = [];
            if (component.ticket && component.ticket.adjuntos) {
                let adjuntos = component.ticket.adjuntos;

                for (let i in adjuntos) {
                    let categoria = adjuntos[i].categoria;
                    let categoriaId = categoria ? categoria.id : -1;
                    if (!adjuntosCategorias.filter(c => c.id === categoriaId).length) {
                        adjuntosCategorias.push({
                            id: categoriaId,
                            nombre: categorias.find(c => c.value === categoriaId).label,
                            adjuntos: []
                        });
                    }
                    adjuntosCategorias.filter(c => c.id === categoriaId).map(c => {
                        c.adjuntos.push({
                            adjunto: adjuntos[i].adjuntoId,
                            archivoNombre: adjuntos[i].archivoNombre
                        })
                    });
                }
            }

            component.setState({
                categoria: component.props.ticket.servicio.categoria ? component.props.ticket.servicio.categoria.id : null,
                categorias: categorias,
                adjuntos: adjuntosCategorias,
                tabSelected: adjuntosCategorias.length ? adjuntosCategorias[0].id : -1
            });
        }).catch(function (error) {
            console.log(error);
        }).finally(() => {

        });
    }

    handleCategoriaChange(categoria) {
        this.setState({
            categoria: categoria ? categoria.value : null
        });
    }

    selectTab(categoria, e) {
        this.setState({
            tabSelected: categoria
        });
    }

    initFileUpload() {
        let component = this;

        this.fileUploadConfig = {
            showFiletypeIcon: false,
            postUrl: Config.get('apiUrlBase') + '/tickets/adjunto'
        };

        this.fileUploadDjsConfig = {
            addRemoveLinks: false,
            thumbnailMethod: 'crop',
            dictDefaultMessage: component.props.intl.formatMessage({ id: 'oTAdjuntos.add_file.label_haga_click_aqui_o', defaultMessage: 'Haga click aquí o' })+"<br>"+component.props.intl.formatMessage({ id: 'oTAdjuntos.add_file.label_arrastre_un_archivo_a_este_area', defaultMessage: 'arrastre un archivo a este área' })+"<br>"+component.props.intl.formatMessage({ id: 'oTAdjuntos.add_file.label_para_cargarlo_en_la_categoria_seleccionada', defaultMessage: 'para cargarlo en la categoría seleccionada.' }),
            uploadMultiple: true,
            parallelUploads: 1,
            headers: {
                "Authorization-Token": localStorage.getItem("token")
            },
            previewTemplate: `
		        <div class="dz-preview dz-image-preview">
		          <div class="dz-image">
		            <img data-dz-thumbnail src="/images/file.png" />
		          </div>
		          <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress="" style="width: 0%;"></span></div>
		          <div class="dz-success-mark">
		            <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">      <title>Check</title>      <defs></defs>      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">        <path d="M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" stroke-opacity="0.198794158" stroke="#747474" fill-opacity="0.816519475" fill="#FFFFFF" sketch:type="MSShapeGroup"></path>      </g>    </svg>
		          </div>
		          <div class="dz-error-mark">
		            <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">      <title>Error</title>      <defs></defs>      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">        <g id="Check-+-Oval-2" sketch:type="MSLayerGroup" stroke="#747474" stroke-opacity="0.198794158" fill="#FFFFFF" fill-opacity="0.816519475">          <path d="M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" sketch:type="MSShapeGroup"></path>        </g>      </g>    </svg>
		          </div>
		          <div class="dz-error-message"><span data-dz-errormessage></span></div>
		        </div>
		    `,
            init: function () {
                let dropzone = this;

                this.on('success', (file, response) => {
                    this.removeFile(this.files[0]);

                    let adjuntos = component.state.adjuntos;
                    let categoriaId = component.state.categoria ? component.state.categoria : -1;
                    let categoria = component.state.categorias.find(e => e.value === categoriaId);

                    let adjuntosCategoria = adjuntos.filter(e => e.id === categoriaId);
                    if (!adjuntosCategoria.length) {
                        adjuntos.push({
                            id: categoria.value,
                            nombre: categoria.label,
                            adjuntos: [{
                                adjunto: response.archivo,
                                archivoNombre: file.name
                            }]
                        });
                    } else {
                        adjuntosCategoria.map(e => e.adjuntos.push({
                            adjunto: response.archivo,
                            archivoNombre: file.name
                        }));
                    }

                    component.setState({
                        adjuntos: adjuntos,
                        tabSelected: categoriaId
                    });
                });

                this.on('error', (file, errormessage, response) => {
                    dropzone.removeFile(file);
                    Dialog.alert(component.props.intl, {
                        title: errormessage.includes('files of this type') ? component.props.intl.formatMessage({ id: 'oTAdjuntos.add_file.error_formato_de_archivo_invalido', defaultMessage: 'Formato de archivo inválido' }) : component.props.intl.formatMessage({ id: 'oTAdjuntos.add_file.error_error_al_cargar_el_archivo', defaultMessage: 'Error al cargar el archivo.' })
                    });
                });
            }
        };

        this.fileUploadHandlers = {
            init: dz => {
                this.adjuntosDropzone = dz;
            }
        };
    }

    handleCancel() {
        this.ajaxHandler.unsubscribe();
        this.props.callbackClose();
    }

    handleViewAdjunto(e, adjunto, name) {
        this.ajaxHandler.fetch('/tickets/adjunto/' + adjunto, {
            method: 'GET'
        }).then(response => {
            if (response.status === 200) {
                return response.blob();
            }
        }).then(fileBlob => {
            // HOTPATCH VEC-4158: antes, los tipos de la whitelist (pdf/imagenes) se
            // abrian con window.open() -- si el navegador los previsualiza en su propio
            // visor (ej. PDF), el boton de descarga de ESE visor no respeta el nombre
            // del archivo (es un contexto aparte, no hereda el .name del blob). Se saca
            // la previsualizacion y se fuerza siempre la descarga directa via
            // <a download>, que si garantiza nombre+extension correctos.
            const namedFile = new File([fileBlob], name, { type: fileBlob.type });
            let fileUrl = URL.createObjectURL(namedFile);
            var fileLink = document.createElement('a')
            fileLink.href = fileUrl
            fileLink.download = name
            fileLink.click()
        }).catch(() => {
        });
        e.preventDefault();
    }

    handleRemoveAdjunto(e, adjunto) {
        let adjuntos = this.state.adjuntos;
        let categoria = adjuntos.filter(categoria => categoria.id === this.state.tabSelected)[0];
        categoria.adjuntos = categoria.adjuntos.filter(a => a.adjunto !== adjunto);
        let tabSelected = this.state.tabSelected;
        if (!categoria.adjuntos.length) {
            adjuntos = adjuntos.filter(c => c.id !== categoria.id);
            tabSelected = adjuntos.length ? adjuntos[0].id : -1;
        }

        this.setState({
            adjuntos: adjuntos,
            tabSelected: tabSelected
        });
        e.preventDefault();
    }

    handleSave(event) {
        let component = this;

        this.setState({ loading: true });
        this.ajaxHandler.fetch('/tickets/adjuntos/' + this.props.ticket.id, {
            method: 'PUT',
            body: JSON.stringify({
                adjuntos: this.state.adjuntos
            })
        }).then(response => {
            if (response.status !== 400) {
                this.setState({
                    loading: false
                }, () => {
                    this.props.callbackSave(component.state.adjuntos);
                });
            }
        }).catch((error) => {
            this.ajaxHandler.handleError(error);
        }).finally(() => {
        });
        event.preventDefault();
    }

    render() {
        let state = this.state;
        let categoria = state.categoria ? state.categorias.find(e => e.value === state.categoria) : null;

        return (
            <React.Fragment>
                {this.ticket && (
                    <React.Fragment>
                        <div className="card pull-up">
                            <div className="card-content pl-1 pr-1">
                                <div className="card-body form">
                                    <h4 className="form-section">
                                        <i className="la la-file"></i><FormattedMessage id="oTAdjuntos.render.adjuntos.header" defaultMessage=" Adjuntos"/>
                                                            </h4>

                                    <div className="row chat-application ml-0 mr-0 mb-1" style={{ border: 0 }}>
                                        <div className="content-body">

                                            {this.props.isModal && (
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group row">
                                                            <label className="col-md-4 label-control col-form-label text-nowrap" htmlFor="categoria">
                                                                <FormattedMessage id="oTAdjuntos.render.adjuntos.label_categoria" defaultMessage="Categoría:"/>
                                                                                        </label>
                                                            <div className="col-md-8">
                                                                <Select
                                                                    id="categoria"
                                                                    name="categoria"
                                                                    placeholder={this.props.intl.formatMessage({ id: 'oTAdjuntos.render.adjuntos.placeholder_categoria', defaultMessage: 'Seleccione' })}
                                                                    options={this.state.categorias}
                                                                    valueKey='value'
                                                                    labelKey='label'
                                                                    value={categoria}
                                                                    onChange={(e) => this.handleCategoriaChange(e)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <DropzoneComponent id="archivos" config={this.fileUploadConfig} eventHandlers={this.fileUploadHandlers} djsConfig={this.fileUploadDjsConfig} />
                                                    </div>

                                                    <hr />
                                                </div>
                                            )}

                                            <div className="row mt-1">
                                                <div className="col-md-12">
                                                    {this.state.adjuntos.filter(categoria => categoria.adjuntos && categoria.adjuntos.length).length ? (
                                                        <React.Fragment>
                                                            <ul className="nav nav-tabs no-hover-bg nav-justified nav-topline">
                                                                {this.state.adjuntos.filter(categoria => categoria.adjuntos && categoria.adjuntos.length).sort((x, y) => x.id === -1 ? -1 : y.id === -1 ? 1 : x.nombre <= y.nombre ? -1 : 1).map((categoria, index) => (
                                                                    <li key={categoria.id} className="nav-item">
                                                                        <a className={'nav-link' + (categoria.id === this.state.tabSelected ? ' active' : '')} id={categoria.id} data-toggle="tab" href={'#' + categoria.id} aria-expanded="true" onClick={(e) => this.selectTab(categoria.id, e)} style={categoria.id === -1 ? { fontWeight: 'bold' } : {}}>{categoria.nombre}</a>
                                                                    </li>
                                                                ))}
                                                            </ul>

                                                            <div className="tab-content px-1 pt-1">
                                                                {this.state.adjuntos.filter(categoria => categoria.adjuntos && categoria.adjuntos.length).sort((x, y) => x.id === -1 ? -1 : y.id === -1 ? 1 : x.nombre <= y.nombre ? -1 : 1).map((categoria, index) => (
                                                                    <div key={categoria.id} role='tabpanel' className="tabpanel" id={categoria.id} aria-labelledby="link-tab" aria-expanded="true" hidden={categoria.id !== this.state.tabSelected}>

                                                                        <table className="table">
                                                                            <tbody style={{ maxHeight: '200px', overflowY: 'auto', display: 'block' }}>
                                                                                {categoria.adjuntos.map((adjunto, index) => (
                                                                                    <tr key={index}>
                                                                                        <td className="align-middle">{adjunto.archivoNombre}</td>
                                                                                        <td className="align-middle">
                                                                                            <button className="action btn btn-icon text-fleet btn-sm btn-dt-grid p-0 m-0" onClick={(e) => this.handleViewAdjunto(e, adjunto.adjunto, adjunto.archivoNombre)} title={this.props.intl.formatMessage({ id: 'oTAdjuntos.render.adjuntos.button_title_ver_adjunto', defaultMessage: 'Ver Adjunto' })} >
                                                                                                <i className="fa fa-paperclip fa-xs"></i>
                                                                                            </button>
                                                                                        </td>
                                                                                        {this.props.isModal && (
                                                                                            <td className="align-middle">
                                                                                                <button className="action btn btn-icon text-fleet text-danger btn-sm btn-dt-grid p-0 m-0" onClick={(e) => this.handleRemoveAdjunto(e, adjunto.adjunto)} title={this.props.intl.formatMessage({ id: 'oTAdjuntos.render.adjuntos.button_title_eliminar', defaultMessage: 'Eliminar' })} >
                                                                                                    <i className="fa fa-trash fa-xs"></i>
                                                                                                </button>
                                                                                            </td>
                                                                                        )}
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </React.Fragment>
                                                    ) : (
                                                            <div><FormattedMessage id="oTAdjuntos.render.adjuntos.information_no_hay_archivos_adjuntos_cargados" defaultMessage="No hay archivos adjuntos cargados."/></div>
                                                        )}
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {this.props.isModal && (
                            <div className="card pull-up">
                                <div className="card-content">
                                    <div className="card-body">
                                        <div className="text-cd text-right">
                                            <button type="submit" className="btn btn-primary mr-1" onClick={this.handleSave}>
                                                <i className="fa fa-check-circle"></i><FormattedMessage id="oTAdjuntos.finish_button.guardar" defaultMessage=" Guardar"/>
                                                    </button>
                                            <button type="button" className="btn btn-danger" onClick={this.handleCancel}>
                                                <i className="fa fa-times-circle"></i><FormattedMessage id="oTAdjuntos.finish_button.cancelar" defaultMessage=" Cancelar"/>
                                                    </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </React.Fragment>
                )}

            </React.Fragment>

        );
    }
}

export default injectIntl(OTAdjuntos);
